import { render, staticRenderFns } from "./drafts_count.vue?vue&type=template&id=cbf4c07c&"
import script from "./drafts_count.vue?vue&type=script&lang=js&"
export * from "./drafts_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports